var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.openTabIds.includes(_vm.id))?_c('div',{class:_vm.$style.file},[_c('div',{class:_vm.$style.file__inner},[(_vm.code)?_c('code',{staticClass:"language-markup"},[_vm._v(_vm._s(_vm.code))]):_vm._e(),_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }